import { createSafeContext } from '@mews/framework';
import { TimelineFilterValues } from '../components/TimelineFilters/timelineFilterSchema';

export const { TimelineFilterValuesContextProvider, useTimelineFilterValuesContext } = createSafeContext<
    'TimelineFilterValuesContext',
    TimelineFilterValues
>('TimelineFilterValuesContext');
